import React from 'react';
import { Route } from 'react-router-dom';

import * as routeLookup from 'App/common/routeLookup';
import InCompleteConfiguration from 'App/features/InCompleteConfiguration/InCompleteConfiguration';
import Login from 'App/features/Login';
import Logout from 'App/features/Logout';
import SupportLogin from 'App/features/SupportLogin';

const PublicRoutes = (
    <>
        <Route path={routeLookup.loginRoute} element={<Login />} />

        <Route path={routeLookup.logoutRoute} element={<Logout />} />

        <Route path={routeLookup.inCompleteConfigurationRoute} element={<InCompleteConfiguration />} />

        <Route path={routeLookup.supportLoginRoute} element={<SupportLogin />} />
    </>
);

export default PublicRoutes;
